module.exports = __webpack_public_path__ + "static/logo-blue-market-d840a49034b8951b42da24f82776f7f0.png";